const EMAIL_FORMAT_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const RESERVED_LOCAL_PART_PATTERN = /\b(test|user)\b/i;

const DISPOSABLE_EMAIL_DOMAINS = new Set([
  "mailinator.com",
  "guerrillamail.com",
  "guerrillamail.net",
  "guerrillamail.org",
  "grr.la",
  "tempmail.com",
  "temp-mail.org",
  "yopmail.com",
  "trashmail.com",
  "10minutemail.com",
  "throwaway.email",
  "getnada.com",
  "maildrop.cc",
  "sharklasers.com",
  "dispostable.com",
  "fakeinbox.com",
  "mailnesia.com",
]);

function getEmailParts(
  email: string,
): { localPart: string; domain: string } | null {
  const trimmed = email.trim();
  const atIndex = trimmed.lastIndexOf("@");
  if (atIndex <= 0 || atIndex === trimmed.length - 1) {
    return null;
  }

  return {
    localPart: trimmed.slice(0, atIndex),
    domain: trimmed.slice(atIndex + 1).toLowerCase(),
  };
}

function isDisposableApplicantEmailDomain(domain: string): boolean {
  const normalized = domain.trim().toLowerCase();
  if (!normalized) return false;

  for (const disposable of DISPOSABLE_EMAIL_DOMAINS) {
    if (normalized === disposable || normalized.endsWith(`.${disposable}`)) {
      return true;
    }
  }

  return false;
}

export function isAbusiveApplicantEmail(email: string): boolean {
  const trimmed = email?.trim() ?? "";
  if (!trimmed) return false;

  if (!EMAIL_FORMAT_PATTERN.test(trimmed)) {
    return true;
  }

  const parts = getEmailParts(trimmed);
  if (!parts) {
    return true;
  }

  if (RESERVED_LOCAL_PART_PATTERN.test(parts.localPart)) {
    return true;
  }

  if (isDisposableApplicantEmailDomain(parts.domain)) {
    return true;
  }

  return false;
}

export function getApplicantEmailAbuseMessage(email: string): string | null {
  const trimmed = email?.trim() ?? "";
  if (!trimmed) {
    return null;
  }

  if (!EMAIL_FORMAT_PATTERN.test(trimmed)) {
    return "Please enter a valid email address.";
  }

  const parts = getEmailParts(trimmed);
  if (!parts) {
    return "Please enter a valid email address.";
  }

  if (RESERVED_LOCAL_PART_PATTERN.test(parts.localPart)) {
    return "Please use a valid personal email address.";
  }

  if (isDisposableApplicantEmailDomain(parts.domain)) {
    return "Temporary or disposable email addresses are not allowed.";
  }

  return null;
}
